// Copyright (c) 2022 by Move Closer

import { computed, ComputedRef, Ref } from '@vue/composition-api'

import { ClassRegistry, ObjectKeyLiterals } from './use-class-registry.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const userClassRegistry = <T extends ObjectKeyLiterals = string>(
  needle: Ref<T>,
  registry: ClassRegistry<T>,
  component: string,
  composable: string,
  strict: boolean,
  fallbackClass: string
): ComputedRef<string> => {
  return computed<string>(() => {
    if (!needle.value) {
      return ''
    }

    if (!Object.keys(registry).length) {
      console.warn(
        `${component} / ${composable}: Provided registry does NOT contain any definition. Used no class.`
      )

      return ''
    }

    if (!(needle.value in registry)) {
      const baseMessage: string = `${component} / ${composable}: Provided registry does NOT contain the given key.`
      if (strict) {
        throw new Error(baseMessage)
      }

      console.warn(`${baseMessage}\nFalling back to the [fallbackClass], which is [${fallbackClass}].`)
      return fallbackClass
    }

    return String(registry[needle.value])
  })
}
